import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, CardContent, Container, Typography
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import echobuddyLogo from '../../assets/newEchoLogo.png';
import { Link } from 'react-router-dom';

const assessments = [
  {
    id: 'swsa',
    icon: <FmdGoodOutlinedIcon sx={{ color: '#22c55e', fontSize: 20 }} />,
    iconBg: 'rgba(34,197,94,0.12)',
    title: 'Subjective Well-Being',
    description:
      'A comprehensive self-assessment based on international scales to evaluate your personal well-being across life experiences.',
    buttonLabel: 'Start Assessment',
    buttonGradient: 'linear-gradient(135deg, #22c55e, #14b8a6)',
    route: '/health-survey',
    ctaKey: 'wellness_assessment',
  },
  {
    id: 'stia',
    icon: <AssessmentIcon sx={{ color: '#8b5cf6', fontSize: 20 }} />,
    iconBg: 'rgba(139,92,246,0.12)',
    title: 'Sound Therapy Impact',
    description:
      'Assess how echoShine sound therapy is impacting your stress, sleep, focus, and emotional well-being with personalised insights.',
    buttonLabel: 'Start Assessment',
    buttonGradient: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
    route: '/stia-survey',
    ctaKey: 'stia_assessment',
  },
];

const ChooseAssessment = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f0f2f8' }}>
      {/* ── Header ── */}
      <Box sx={{
        width: '100%', px: { xs: 2, sm: 4, md: 6 }, py: 1.2,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        backgroundColor: 'white', borderBottom: '1px solid #E5E7EB',
      }}>
        <Link to="/home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img src={echobuddyLogo} alt="echoShine" style={{ height: 40, width: 40, borderRadius: '50%', objectFit: 'cover' }} />
          <Box>
            <Typography sx={{ fontSize: '1.2rem', fontWeight: 700, color: '#7843f3', lineHeight: 1.1 }}>
              echoShine
            </Typography>
            <Typography variant="caption" sx={{ color: '#7843f3', fontSize: '0.6rem', fontWeight: 500, display: 'block' }}>
              Connect. Heal. Rise.
            </Typography>
          </Box>
        </Link>

        <Button startIcon={<ArrowBackIosIcon sx={{ fontSize: 13 }} />} onClick={() => navigate('/home')}
          sx={{ textTransform: 'none', color: '#6b7c93', fontSize: '0.85rem', fontWeight: 500 }}>
          Back
        </Button>
      </Box>

      {/* ── Content ── */}
      <Container maxWidth="md" sx={{ py: { xs: 5, sm: 8 } }}>
        {/* Title */}
        <Box sx={{ textAlign: 'center', mb: { xs: 4, sm: 6 } }}>
          <Typography variant="h4" fontWeight={700} sx={{
            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
            mb: 1.5, fontSize: { xs: '1.6rem', sm: '2rem' }
          }}>
            Choose Your Assessment
          </Typography>
          <Typography color="text.secondary" sx={{ fontSize: '0.9rem', maxWidth: 520, mx: 'auto', lineHeight: 1.7 }}>
            Select an assessment type to begin your wellness journey. Each assessment is designed to help you understand and improve different aspects of your well-being.
          </Typography>
        </Box>

        {/* Cards */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
          {assessments.map((a) => (
            <Card key={a.id} sx={{
              borderRadius: 3, background: '#ffffff',
              border: '1px solid #e8eaf0', boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              transition: 'all 0.3s ease',
              '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 12px 32px rgba(0,0,0,0.1)' }
            }}>
              <CardContent sx={{ p: { xs: 3, sm: 3.5 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: a.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {a.icon}
                  </Box>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#1e293b', fontSize: '0.95rem' }}>
                    {a.title}
                  </Typography>
                </Box>

                <Typography sx={{ color: '#6b7c93', fontSize: '0.83rem', lineHeight: 1.6, mb: 3, minHeight: 60 }}>
                  {a.description}
                </Typography>

                <Button variant="contained" fullWidth
                  // onClick={() => navigate(a.route)}
                  onClick={() => navigate(a.route, { state: { newAssessment: true } })}
                  sx={{
                    py: 1.1, borderRadius: 2, textTransform: 'none', fontWeight: 600,
                    fontSize: '0.88rem', color: '#fff', border: 'none',
                    background: a.buttonGradient,
                    boxShadow: 'none',
                    '&:hover': { opacity: 0.9, boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }
                  }}>
                  {a.buttonLabel}
                </Button>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ChooseAssessment;
